<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >试卷ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.id"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >试卷名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleCreate('create')"
                >新增</el-button
              >
            </div>
          </div>
        </div>
      </template>

      <template slot="state" slot-scope="{ row }">
        <el-switch
          :value="row.state"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button
          type="text"
          size="mini"
          @click="handleCreate('update', row.id)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
          style="color: #ff001f !important"
          v-if="row.id != 'b8470908e0c341fd2643a017b8d38282'"
          >删除</el-button
        >
        <el-button type="text" size="mini" @click="handleVideo(row.id)"
          >设置学习视频</el-button
        >
      </template>
    </avue-crud>
    <FactoryForm
      ref="formRef"
      @success="handleSearch"
      :classifyList="classifyList"
    />
    <!-- 设置学习视频 -->
    <CompletionRateForm ref="completionRateFormRef" />
  </div>
</template>

<script>
import {
  questionTestList,
  questionTestDelete,
  questionTestStateUpdate,
} from "@/api/question/test";
import { mapGetters } from "vuex";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import FactoryForm from "./FactoryForm.vue";

import CompletionRateForm from "./completionRateForm.vue";
export default {
  name: "index",
  components: {
    FormImgUpload,
    FactoryForm,

    CompletionRateForm,
  },

  data() {
    return {
      isDetails: false,
      searchData: {
        name: "",
        id: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "试卷ID",
            prop: "id",
          },
          {
            label: "试卷名称",
            prop: "name",
          },
          {
            label: "试卷总分",
            prop: "totalScore",
          },
          {
            label: "及格分数",
            prop: "passScore",
          },
          {
            label: "必须学习的视频",
            prop: "videoNum",
          },

          {
            label: "视频总时长（h）",
            prop: "videoTime",
          },
          {
            label: "考试时长（min）",
            prop: "examTime",
          },
          {
            label: "启用状态",
            prop: "state",
          },
          {
            label: "操作人",
            prop: "createBy",
          },
          {
            label: "操作时间",
            prop: "createTime",
          },
        ],
      },

      dialogVisible: false,
      form: {
        image: [],
        equityIds: [],
      },

      dialogPassWordVisible: false,
      dataUrl: "",
      classifyList: [], //分类下拉
    };
  },
  created() {},
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      this.showLoading = true;
      questionTestList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    handleCreate(type, id) {
      this.$refs.formRef.open(type, id);
    },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      this.searchData = {
        title: "",
        code: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        questionTestDelete(row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          }
        });
      });
    },
    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
      };
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },

    //切换是否显示
    handleSwitch(e, id) {
      questionTestStateUpdate({
        id: id,
        state: e,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        }
        this.onLoad();
      });
    },

    // 批量导入
    handleImport() {
      console.log("导入");
      this.importShow = true;
    },
    // 导入弹框关闭
    importClose(e) {
      this.importShow = false;
      console.log("e111", e);
      this.onLoad();
    },
    // 跳转项目信息
    jumpProjectInfo(id) {
      this.$router.push({
        path: "/factory/project",
        query: { id },
      });
    },
    // 设置学习视频
    handleVideo(id) {
      console.log(id, "id");
      this.$refs.completionRateFormRef.open(id);
    },
  },
};
</script>

<style scoped>
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
img {
  width: 100%;
  height: 100%;
}
</style>
